import OpcionesRespuestaLayer from "../../components/preguntasTalento/OpcionesRespuestaLayer";

const OpcionesRespuestaPage = () => <OpcionesRespuestaLayer />;

export default OpcionesRespuestaPage;
